/**
 * 铸剑阁评分系统（Task 1）
 *
 * 根据战斗表现动态计算评分等级：S / A / B / C
 * 评分标准基于玩家剩余 HP 和战斗耗时
 */

/**
 * 计算铸剑阁战斗评分
 *
 * @param playerHp - 玩家剩余 HP（0-150）
 * @param totalTicks - 战斗耗时（ticks）
 * @param maxTime - 关卡最大时间（ticks）
 * @returns 评分等级：S / A / B / C
 *
 * 评分标准：
 * - S: HP > 100 && 耗时 < 最大时间 × 0.5（快速高效）
 * - A: HP > 75 && 耗时 < 最大时间 × 0.75（稳定高效）
 * - B: HP > 50 && 耗时 < 最大时间（基础通关）
 * - C: 其他（勉强通关）
 */
export function calculateForgeScore(
  playerHp: number,
  totalTicks: number,
  maxTime: number
): "S" | "A" | "B" | "C" {
  // S 级：血量充足 + 时间快速
  if (playerHp > 100 && totalTicks < maxTime * 0.5) {
    return "S";
  }

  // A 级：血量良好 + 时间稳定
  if (playerHp > 75 && totalTicks < maxTime * 0.75) {
    return "A";
  }

  // B 级：血量及格 + 时间正常
  if (playerHp > 50 && totalTicks < maxTime) {
    return "B";
  }

  // C 级：其他（勉强通关）
  return "C";
}
